export type Phone = {
  id: number;
  number: string;
  countryCode: string;
};

export type ListingsResponseType = {
  slug: string;
  listing_phones: Phone[];
  phones: Phone[];
  mainPhoto: {
    id: number;
    thumbnails: {
      thumb: string;
    };
  } | null;
  photos: StackedCardListingPhotosType[];
  has_parent: boolean;
  attributes: {
    rooms: string | null;
    floor: string | null;
    baths: string;
    yearBuild: string;
    finishType: string;
    finishTypeLabel: string;
  } | null;
  whatsAppNumber: string;
  id: number;
  title: string;
  description: string;
  section: ListingCardSectionType;
  area: number;
  price: number;
  address: string;
  location: StackedCardListingLocationType;
  user: StackedCardListingUserType;
  isCallRequest: boolean;
  latitude: number;
  longitude: number;
  video_url: string | null;
  published_at: string;
};

export type ListingLocationType = Pick<
  StackedCardListingLocationType,
  'title_full_path' | 'slug' | 'id'
> & {
  parent: StackedCardListingLocationType['parent'];
  name: string;
};

export type PaymentPlanType = {
  id: number;
  down_payment: number;
  price: number;
  duration: number;
};

export enum PaymentMethodEnum {
  CASH = 1,
  INSTALLMENT = 2,
}

export enum SectionsEnum {
  FOR_SALE = 'for-sale',
  FOR_RENT = 'for-rent',
}

export type ListingCardType = {
  slug: string;
  phones: Phone[];
  photos: { src: string; id: number }[];
  photosCount: number;
  attributes: {
    rooms: string | null;
    baths: string | null;
    finishType: string | null;
    floor: string | null;
  } | null;
  whatsAppNumber: string;
  id: number;
  title: string;
  section: ListingCardSectionType;
  area: number;
  price: number;
  address?: string;
  location: ListingLocationType;
  user: {
    id?: number;
    phoneNumber?: string;
    has_active_logo_service?: boolean;
    logo?: string;
    fullName?: string;
  };
  video_url: string | null;
};

export type StackedCardListingPhotosType = {
  id: number;
  thumbnails: {
    thumb: string;
  };
};

export type ListingCardSectionType = {
  id: number;
  slug: string;
};

export type StackedCardListingLocationType = {
  title_full_path: string;
  id: number;
  slug: string;
  parent?: {
    title_full_path: string;
    id: number;
    slug: string;
  };
};

export type StackedCardListingUserType = {
  id: number;
  phoneNumber: string;
  activeListingsCount: number;
  hasActiveSubscription: boolean;
  fullName: string;
  createdAt: string;
  countryCode: string;
  email: string;
  clientsServedCount: number;
  has_active_logo_service: boolean;
  logo: {
    id: number;
    thumbnails: {
      logo: string;
    };
  };
};

export type PaginateType = {
  limit: number;
  page: number;
  totalPages: number;
  totalCount: number;
  isLastPage: boolean;
};

export type ListingCardDefaultType = {
  statusCode: number;
  statusMessage: string;
  paginate: PaginateType;
  data: ListingCardType[];
};

export type ListingSearchResponseType = {
  default: {
    statusCode: number;
    statusMessage: string;
    paginate: {
      limit: number;
      page: number;
      totalPages: number;
      totalCount: number;
      isLastPage: boolean;
    };
    data: ListingsResponseType[];
  };
};
